import Layout from '@/layout'

const route = {
  path: '/copyiaarouterNative',
  component: Layout,
  redirect: '/copyiaarouterNative/index',
  alwaysShow: true, // will always show the root menu
  name: 'releaseGroupNative',
  meta: {
    title: 'IAA素材报表(端原生)',
    icon: 'IAA',
    roles: [
      'iaaMaterialReportNative'
    ]
  },
  children: [
    {
      path: '/iaapitcherNative/index',
      component: () => import('@/views/iaapitcherNative/index.vue'),
      name: 'IaapitcherNative',
      meta: {
        title: '绑定关系管理',
        icon: 'component',
        roles: [
          'iaaMaterialReportNative.bindRelation'
        ]
      }
    }, {
      path: '/iaareturneNative/index',
      component: () => import('@/views/iaareturneNative/index.vue'),
      name: 'IaareturneNative',
      meta: {
        title: 'IAA回收',
        icon: 'component',
        roles: [
          'iaaMaterialReportNative.report.recyclingList.group'
        ]
      }
    }, {
      path: '/iaapitchernewNative/index',
      component: () => import('@/views/iaapitchernewNative/index.vue'),
      name: 'IaapitchernewNative',
      meta: {
        title: '投手数据',
        icon: 'component',
        roles: [
          'iaaMaterialReportNative.report.pitcherList.group'
        ]
      }
    }, {
      path: '/iaapitcherEarningsRankNative/index',
      component: () => import('@/views/iaapitcherEarningsRankNative/index.vue'),
      name: 'IaapitcherEarningsRankNative',
      meta: {
        title: '投手收益排行',
        icon: 'component',
        roles: [
          'iaaMaterialReportNative.report.pitcherEarningsRank.group'
        ]
      }
    }, {
      path: '/iaabigboardNative/index',
      component: () => import('@/views/iaabigboardNative/index.vue'),
      name: 'IaabigboardNative',
      meta: {
        title: '大看板',
        icon: 'component',
        roles: [
          'iaaMaterialReportNative.report.bigDataDashboard.group'
        ]
      }
    }, {
      path: '/iaadatareportNative/index',
      component: () => import('@/views/iaadatareportNative/index.vue'),
      name: 'IaadatareportNative',
      meta: {
        title: '素材报表（仅消耗）',
        icon: 'component',
        roles: [
          'iaaMaterialReportNative.report.costList.group'
        ]
      }
    },
    {
      path: '/iaapeoplelistNative/index',
      component: () => import('@/views/iaapeoplelistNative/index.vue'),
      name: 'IaapeoplelistNative',
      meta: {
        title: '投手详情',
        icon: 'component',
        noCache: true,
        roles: [
          'iaaMaterialReportNative.report.pitcherEarningsRank.group'
        ]
      },
      hidden: true
    }
  ]
}

export default route

